module.exports = __webpack_public_path__ + "img/guanyu.c5ec09cd.png";